import rainbowSDK from 'rainbow-web-sdk';

export var messageQueue = [];

export function sendMsgToServer(channel, msg) {
  if (channel != '') {
    //console.log("ChannnelID"+channel);
    var message = '#AGENT#' + JSON.stringify(msg);
    var title = 'vACD';
    var type = 'basic';
    //console.log(msg);
    rainbowSDK.channels
      .createItem(channel.id, message, title, type)
      .then(() => {
        console.log('Message Posted On Channel');
      })
      .catch(
        (err) => {
          console.log('Error Posting Message:' + err);
        } /*something went wrong*/
      );
  }
}

var currentMsgID = '';
export function getMsgFromServer(channelID) {
  //console.log(channelID);
  rainbowSDK.channels
    .fetchItems(channelID)
    .then(function (response) {
      if (response.length > 0) {
        return processSinlgeMessage(response[0]);

        //return response[0];
        // if(currentMsgID != response[0].id)
        // {
        // currentMsgID = response[0].id;
        //window.response = response[0];
        //response.forEach(processMsg);
        //}
      } else return null;
    })
    .catch((err) => console.log('Error fetching message: ' + err));
}

function processSinlgeMessage(item) {
  try {
    var serverResponse = item.entry.message;

    //CHECK IF MESSAGE RECEIVED FROM CHANNEL IS A MESSAGE FROM THE SERVER. IT SHOULD START WITH #SERVER# OTHERWISE IGNORE AND REMOVE FROM QUEUE
    if (serverResponse.search('#SERVER#') == -1) {
      console.log('No Server Response in Channel');

      return null;
    } else {
      let jsonMessage = JSON.parse(serverResponse.slice(8)); //REMOVE THE #SERVER# PART FROM THE STRING SO JSON CAN BE PARSED

      if (jsonMessage.Type === 'AGENT_STATE') {
        return jsonMessage;
      }
    }
  } catch (err) {}
}
function processMsg(item) {
  messageQueue.push(item);
  let d = new Date();
  console.log('Message Fetched: ' + item.id + ' @ ' + d.getTime());
  rainbowSDK.channels
    .deleteItem(item.channelId, item.id)
    .then(function (resp) {
      let d = new Date();
      console.log('Message Deleted Successfully:' + item.id + ' @ ' + d.getTime());
    })
    .catch((err) => {
      let d = new Date();
      console.log('Error Deleting Message: ' + item.id + '---' + err + ' @ ' + d.getTime());
    });
}

export function deleteMsgFromServer(channelID, itemID) {
  let cid = channelID;
  let id = itemID;
  rainbowSDK.channels
    .deleteItem(cid, id)
    .then(function (response) {
      console.log('Message Deleted Successfully');
    })
    .catch((err) => console.log('Error Deleting Message: ' + err));
}
